import { render, staticRenderFns } from "./shortMessage.vue?vue&type=template&id=d1d35c70"
import script from "./shortMessage.vue?vue&type=script&lang=js"
export * from "./shortMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports